@if (isBYBChecked && isFlagChecked) {
    <div class="promotion-icons-wrapper">
        @if (mulSignPosts) {
            <div class="promotion-icons-wrapper">
                @if (!sId) {
                    <ng-template [ngTemplateOutlet]="lazyBirIcon"></ng-template>
                }
                @if (type === 'event' && showBybLabel()) {
                    <div class="promotion-icon-container">
                        <lazy-component
                            moduleUri="@lazy-modules-module/bybLabel/byb-label.module#BybLabelModule"
                            entryComponent="BybLabelComponent"
                            [inputs]="{ mode: 'sm', event: event, bwinId: bwinId, changeStrategy: 'onpush', iconsCount: iconsCount, isEDPPage }">
                        </lazy-component>
                    </div>
                }
                @if (!sId) {
                    <ng-template [ngTemplateOutlet]="bogIcon"></ng-template>
                }

                @if (isPromoSignpostingEnabled && available && mulSignPosts) {
                    @if (promoIcons && promoIcons.length) {
                        <div
                            class="prom-icons"
                            [ngClass]="{ 'm-l-1': isIP || isHP, 'twoup-margin': isBetReceipt === true }"
                            data-crlat="promotionIcons">
                            @for (icon of promoIcons; track trackByPromoIcon($index, icon)) {
                                @if (icon.iconId) {
                                    @if (mode === 'big') {
                                        <div class="prom-icon" (click)="iconAction($event, icon)" [ngClass]="{ 'big-icon': mode === 'big' }">
                                            <div class="prom-icon-container" data-crlat="promotionIcons">
                                                <svg
                                                    [ngClass]="icon.flagName"
                                                    class="select-arrow"
                                                    [attr.data-crlat]="'promotionIcon.' + icon.flagName">
                                                    <use [attr.xlink:href]="icon.iconId"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    } @else {
                                        <div
                                            class="promotion-icon-container event-card-label-wrapper promotion-icon-margin"
                                            [ngClass]="{
                                                'small-icon': mode === 'sm',
                                                'middle-icon': mode === 'md',
                                                'mini-icon': mode === 'mini',
                                                'small-icon-margin': disablePopUp && mode === 'sm',
                                                'gery-two-up': isTwoUpSettlementDone === 0,
                                            }"
                                            (click)="!disablePopUp && iconAction($event, icon)">
                                            <svg
                                                class="event-card-label"
                                                [ngClass]="[icon.flagName, isIP || isHP ? 'pifi' : '']"
                                                [attr.data-crlat]="'promotionIcon.' + icon.flagName">
                                                <use
                                                    [attr.xlink:href]="
                                                        isTwoUpSettlementDone === 0 || isQuaccaBar ? icon.greyIconId : icon.iconId
                                                    "></use>
                                            </svg>
                                            @if (!sId && !isIP && !isHP) {
                                                @if (isQuaccaBar) {
                                                    <span
                                                        class="event-card-text"
                                                        [ngClass]="{ 'event-card-text-grey': isTwoUpSettlementDone === 0 }"
                                                        [i18n]="'bs.twoUpMsg'">
                                                    </span>
                                                } @else {
                                                    <span
                                                        class="event-card-text"
                                                        [ngClass]="{ 'event-card-text-grey': isTwoUpSettlementDone === 0 }"
                                                        [i18n]="'bma.' + icon.promoName">
                                                    </span>
                                                }
                                            }
                                        </div>
                                    }
                                    @if (icon.flagName == 'two-up' && isTwoUpSettlementDone === 1) {
                                        <div class="rectangle-green" [ngClass]="{ 'rectangle-green-mobile': isMobile }">
                                            <span class="two-up-got-it" [ngClass]="{ 'two-up-got-it-mobile': isMobile }" [i18n]="'bma.gotIt'"> </span>
                                        </div>
                                    }
                                }
                            }
                        </div>
                    }
                }
                @if (showBybLabel() && type === 'market') {
                    <div class="promotion-icon-container">
                        <lazy-component
                            moduleUri="@lazy-modules-module/bybLabel/byb-label.module#BybLabelModule"
                            entryComponent="BybLabelComponent"
                            [inputs]="{ mode: mode, iconsCount: iconsCount, event: event, bwinId: bwinId, changeStrategy: 'onpush', isEDPPage }">
                        </lazy-component>
                    </div>
                }
                @if ((cashoutAvailable || signpostIconDisplay === 'cashoutAvailable') && sport === 'sport' && !bybTabAvb()) {
                    <cashout-label class="promotion-icon-container" [mode]="mode"> </cashout-label>
                }
            </div>
        } @else if (isPromoSignpostingEnabled && available) {
            <div class="prom-icons">
                @for (icon of signPostFilteredObj; track trackByPromoIcon($index, icon)) {
                    @if (icon.iconId) {
                        @if (mode === 'big') {
                            <div class="prom-icon" (click)="iconAction($event, icon)" [ngClass]="{ 'big-icon': mode === 'big' }">
                                <div class="prom-icon-container">
                                    <svg [ngClass]="icon.flagName" class="select-arrow" [attr.data-crlat]="'promotionIcon.' + icon.flagName">
                                        <use [attr.xlink:href]="icon.iconId"></use>
                                    </svg>
                                </div>
                            </div>
                        } @else {
                            <div
                                class="promotion-icon-container event-card-label-wrapper"
                                [ngClass]="{ 'small-icon': mode === 'sm', 'middle-icon': mode === 'md', 'mini-icon': mode === 'mini' }"
                                (click)="!disablePopUp && iconAction($event, icon)">
                                <svg class="event-card-label" [ngClass]="icon.flagName" [attr.data-crlat]="'promotionIcon.' + icon.flagName">
                                    <use [attr.xlink:href]="icon.iconId"></use>
                                </svg>
                                @if (!sId && !isIP && !isHP) {
                                    <span class="event-card-text" [i18n]="'bma.' + icon.promoName"> </span>
                                }
                            </div>
                        }
                    }
                }
            </div>
        }

        @if (sId) {
            <ng-template [ngTemplateOutlet]="lazyBirIcon"></ng-template>
            <ng-template [ngTemplateOutlet]="bogIcon"></ng-template>
        }

        @if (singleSignPost) {
            <div>
                <button class="singleSignPost" (click)="mulSignPostsClick($event)">+{{ iconsCount - 1 }}</button>
            </div>
        }
    </div>
}

<ng-template #lazyBirIcon>
    <lazy-component
        class="prom-icons"
        [inputs]="{
            isLazyBIRSignpost: true,
            type,
            display,
            marketName,
            isHeaderBIRAvailable,
            eventDrillDownTags,
            showBIRSignPost,
            mode,
            isAnyIconAvailable,
            iconsCount,
        }"
        [outputs]="['iconCountUpdated']"
        (event)="handleLazyPromotionIconEvent($event)"
        moduleUri="@lazy-modules-module/lazyPromotionIcons/lazy-promotion-icons.module#LazyPromotionIconsModule"
        entryComponent="LazyPromotionIconsComponent"
        (init)="lazyPromotionComponentLoaded()">
    </lazy-component>
</ng-template>
<ng-template #bogIcon>
    @if ((isGpAvailable && isBogCmsEnabled) || signpostIconDisplay === 'isGpAvailable') {
        <div
            class="promotion-icon-container event-card-label-wrapper bog-margin"
            [ngClass]="bogIconStyle ? 'bog-promotion' : 'middle-icon'"
            (click)="bogAction($event)"
            data-crlat="bogIcon">
            <svg class="event-card-label bog-text"><use xlink:href="#bog-text"></use></svg>
        </div>
    }
</ng-template>
